import React from 'react';
import { useCharacterModal } from './hooks/useCharacterModal';
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalTitle,
  CloseButton,
  CharacterAvatar,
  Form,
  FormSection,
  SectionTitle,
  InputGroup,
  Input,
  TextArea,
  Select,
  ButtonGroup,
  PrimaryButton,
  SecondaryButton
} from './styles/CharacterModalStyles';

function CharacterModal({ isOpen, onClose, onSave, character }) {
  const {
    formData,
    isLoading,
    handleInputChange,
    handleSubmit,
    resetForm
  } = useCharacterModal(character, onSave, onClose);

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>
            <span>{character ? 'Edit Character' : 'Add Character'}</span>
          </ModalTitle>
          <CloseButton onClick={onClose} aria-label="Close modal">
            ×
          </CloseButton>
        </ModalHeader>

        <CharacterAvatar>
          {formData.name ? formData.name.charAt(0).toUpperCase() : '?'}
        </CharacterAvatar>

        <Form onSubmit={handleSubmit}>
          <FormSection>
            <SectionTitle>Basic Information</SectionTitle>

            <InputGroup>
              <Input
                type="text"
                placeholder="Character Name"
                value={formData.name}
                onChange={(e) => handleInputChange('name', e.target.value)}
                required
                aria-label="Character name"
              />
            </InputGroup>

            <InputGroup>
              <Input
                type="text"
                placeholder="Character Description"
                value={formData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
                aria-label="Character description"
              />
            </InputGroup>
          </FormSection>

          <FormSection>
            <SectionTitle>System Prompt</SectionTitle>

            <InputGroup>
              <TextArea
                placeholder="Enter the system prompt for this character..."
                value={formData.systemPrompt}
                onChange={(e) => handleInputChange('systemPrompt', e.target.value)}
                rows={4}
                required
                aria-label="System prompt"
              />
            </InputGroup>
          </FormSection>

          <FormSection>
            <SectionTitle>AI Configuration</SectionTitle>

            <InputGroup>
              <Select
                value={formData.model}
                onChange={(e) => handleInputChange('model', e.target.value)}
                aria-label="AI model"
              >
                <option value="claude-3-5-sonnet-20240620">Claude 3.5 Sonnet</option>
                <option value="claude-3-haiku-20240307">Claude 3 Haiku</option>
                <option value="gpt-4">GPT-4</option>
                <option value="gpt-3.5-turbo">GPT-3.5 Turbo</option>
              </Select>
            </InputGroup>

            <InputGroup>
              <Input
                type="number"
                placeholder="Max Tokens"
                value={formData.maxTokens}
                onChange={(e) => handleInputChange('maxTokens', parseInt(e.target.value))}
                min="1"
                max="4000"
                aria-label="Maximum tokens"
              />
            </InputGroup>

            <InputGroup>
              <Input
                type="number"
                placeholder="Temperature"
                value={formData.temperature}
                onChange={(e) => handleInputChange('temperature', parseFloat(e.target.value))}
                min="0"
                max="2"
                step="0.1"
                aria-label="Temperature"
              />
            </InputGroup>
          </FormSection>

          <ButtonGroup>
            <SecondaryButton
              type="button"
              onClick={() => {
                resetForm();
                onClose();
              }}
            >
              Cancel
            </SecondaryButton>
            <PrimaryButton type="submit" disabled={isLoading}>
              {isLoading ? 'Saving...' : 'Save Character'}
            </PrimaryButton>
          </ButtonGroup>
        </Form>
      </ModalContent>
    </ModalOverlay>
  );
}

export default CharacterModal;